export default "__VITE_ASSET__ZCFqMPGR__"